import {Record, Map} from "immutable"

export enum Fired {
    No = 'no',
    Fired = 'fired',
    Army = 'army',
    Moved = 'moved',
}

export enum Gender {
    Male = 'male',
    Female = 'female',
}

interface Properties {
    id: number
    inner: boolean
    target: boolean
    gpa: number
    name: string
    position: string
    age: number
    gender: Gender
    fired: Fired
    firedName: string
    genderName: string
    employedBeforeGraduation: boolean
    constructionTeam: boolean
    hiPo: boolean
    hiPoType: string
    hiPoTypeName: string
    trained: boolean
    practiceEducational: boolean
    practiceUndergraduate: boolean
    details: string
    detailsGraduate: string
    diploma: string
    demandYear: number
    employmentRegionId: number
}

export class Employee extends Record({
    id: undefined,
    inner: undefined,
    target: undefined,
    gpa: undefined,
    name: undefined,
    position: undefined,
    age: undefined,
    gender: undefined,
    fired: undefined,
    firedName: undefined,
    genderName: undefined,
    employedBeforeGraduation: undefined,
    constructionTeam: undefined,
    hiPo: undefined,
    hiPoType: undefined,
    hiPoTypeName: undefined,
    trained: undefined,
    practiceEducational: undefined,
    practiceUndergraduate: undefined,
    details: undefined,
    detailsGraduate: undefined,
    diploma: undefined,
    demandYear: undefined,
    employmentRegionId: undefined,
}) implements Properties {
    id: number
    inner: boolean
    target: boolean
    gpa: number
    name: string
    position: string
    age: number
    gender: Gender
    fired: Fired
    firedName: string
    genderName: string
    employedBeforeGraduation: boolean
    constructionTeam: boolean
    hiPo: boolean
    readonly hiPoType: string
    readonly hiPoTypeName: string
    trained: boolean
    practiceEducational: boolean
    practiceUndergraduate: boolean
    details: string
    detailsGraduate: string
    diploma: string
    demandYear: number
    readonly employmentRegionId: number

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    inner: number
    target: number
    gpa: number
    name: string
    position: string
    age: number
    fired: Fired
    gender: Gender
    firedName: string
    genderName: string
    employedBeforeGraduation: number
    constructionTeam: number
    hiPo: number
    hiPoType: string
    hiPoTypeName: string
    trained: number
    practiceEducational: number
    practiceUndergraduate: number
    details: string
    detailsGraduate: string
    diploma: string
    demandYear: number
    employmentRegionId: number
}

export const fromJs = ({
    id,
    inner,
    target,
    gpa,
    name,
    position,
    age,
    fired,
    gender,
    firedName,
    genderName,
    employedBeforeGraduation,
    constructionTeam,
    hiPo,
    hiPoType,
    hiPoTypeName,
    trained,
    practiceEducational,
    practiceUndergraduate,
    details,
    detailsGraduate,
    diploma,
    demandYear,
    employmentRegionId,
}: JsonData): Employee => new Employee({
    id,
    inner: !!inner,
    target: !!target,
    gpa,
    name,
    position,
    age,
    fired,
    gender,
    firedName,
    genderName,
    employedBeforeGraduation: !!employedBeforeGraduation,
    constructionTeam: !!constructionTeam,
    hiPo: !!hiPo,
    hiPoType,
    hiPoTypeName,
    trained: !!trained,
    practiceEducational: !!practiceEducational,
    practiceUndergraduate: !!practiceUndergraduate,
    details,
    detailsGraduate,
    diploma,
    demandYear,
    employmentRegionId,
})

export type Employees = Map<number, Employee>